import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { SelectorFieldResult } from '../selector-field';

Component('tr-multiple-select-field-result', {
  extends: [SelectorFieldResult],

  mixins: [eventListenerMixin],

  properties: {
    selected: {
      type: Boolean,
      default: false,
      observer() {
        if (this.selectedChanged) this.selectedChanged();
      },
    },
  },

  ready() {
    this.selectedOptions = [];
    this.selectTrigger = this.querySelector('.select-trigger');
    this.resultChipSet = this.querySelector('tr-chip-set');

    this.clearResult();

    this.listenTo(this.selectTrigger, 'click', () => {
      this.namespacedTrigger('active');
    });
    this.listenTo(this.resultChipSet, {
      'tr-chip-set:removal': this.handleChipRemoval.bind(this),
    });
  },

  selectOption(option) {
    if (!option) return false;
    if (this.selectedOptions.find(s => s.value === option.value)) return false;

    this.selectedOptions.push(option);
    this.selected = true;
    this.setSelectedOption(option);
    this.setSelectedResult(option);

    return true;
  },

  unselectOption(option) {
    if (!option) return false;

    const selectedIndex = this.selectedOptions.findIndex(s => s.value === option.value);
    if (selectedIndex === -1) return false;

    this.selectedOptions.splice(selectedIndex, 1);
    this.selected = this.selectedOptions.length > 0;
    this.unsetSelectedOption(option);
    this.unsetSelectedResult(option);

    return true;
  },

  clearSelected() {
    this.selectedOptions.forEach(option => this.unsetSelectedOption(option));
    this.selectedOptions = [];
    this.selected = false;
    this.clearResult();
  },

  clearResult() {
    this.resultChipSet.removeChip('.mdc-chip[data-value]');
  },

  setSelectedOption(option) {
    if (!option) return;

    const nativeOption = [...this.nativeField.options].find(opt => opt.value === option.value);
    if (nativeOption) {
      nativeOption.selected = true;
    } else {
      this.nativeField.appendChild(this.generateNativeOption(option));
    }
  },

  unsetSelectedOption(option) {
    if (!option) return;

    const nativeOption = [...this.nativeField.options].find(opt => opt.value === option.value);
    if (nativeOption) nativeOption.selected = false;
  },

  setSelectedResult(option) {
    if (!option) return;

    const chip = this.resultChipSet.addChip({
      text: option.text,
      icon: option.data.icon,
      avatar: option.data.avatar,
      data: { value: option.value, ...option.dataAttributes },
    });
    chip.setAttribute('data-value', option.value);
  },

  unsetSelectedResult(option) {
    if (!option) return;
    this.resultChipSet.removeChip(`.mdc-chip[data-value="${option.value}"]`);
  },

  handleChipRemoval(event) {
    const option = this.selectedOptions
      .find(selectedOption => selectedOption.value === event.detail.dataset.value);

    if (option) {
      this.namespacedTrigger('unselect', { detail: option });
    }
  },
});
